import React, { Component } from 'react'
import { Route, Link, NavLink, Redirect } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import TimeAgo from 'react-timeago'
import { ClipLoader } from 'react-spinners'

import app_store_button from './images/appstore.png'
import play_store_button from './images/playstore.png'
import graphic from './images/graphic11.png'
import mobile_graphic from './images/mobile_graphic4.png'
import header_image from './images/header6.png'
import mobile_header_image from './images/header_mobile.png'
import screenshot1 from './images/screenshot1.png'
import screenshot2 from './images/screenshot22.png'
import screenshot3 from './images/screenshot35.png'
import screenshot4 from './images/screenshot42.png'
import bitcoin_qr from './images/bitcoin_qr.png'
import ethereum_qr from './images/ethereum_qr.png'
import discord from './images/discord_logo.png'
import logo from './images/logo.png'
import full_logo from './images/full_logo.png'
import legal_logo from './images/legal_logo.png'
import farewell_logo from './images/farewell_logo.png'

import './App.css'
import './Mobile.css'
import './Legal.css'

import Licenses from './Licenses';

const BASE_API_URL = "https://api.winno.app"

//<Route exact path="/" component={Darken} />

class App extends Component {

  render() {
    return (
      <div className="main-container">
        <Route exact path="/" component={Nav} />
        <Route exact path="/" component={Header} />
        <Route exact path="/" component={Ticker} />
        <Route exact path="/" component={Graphic} />
        <Route exact path="/" component={Process} />
        <Route exact path="/" component={Values} />
        <Route exact path="/" component={Manifesto} />
        {/*<Route exact path="/" component={Contact} />*/}
        {/* <Route exact path="/" component={Contribute} /> */}
        {/* <Route exact path="/" component={FutureTicker} /> */}
        <Route exact path="/" component={Reviews} />
        {/*<Route exact path="/browse" component={Browse} />
        <Route exact path="/mission" component={About} />*/}
        <Route exact path="/f/:name" render={(props) => (
          <Feed name={props.match.params.name} />
        )} />
        <Tooltips />
        <Route exact path="/" component={Footer} />
        <Route exact path="/tutorial" component={Tutorial} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/farewell" component={Farewell} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/legal" component={Legal} />
        <Route exact path="/contact" component={ContactMobile} />
        <Route exact path="/share" component={ShareRedirect} />
        <Route exact path="/:id/ask" render={(props) => (
    			<Question feed_id={props.match.params.id} />
				)} />
      </div>
    )
  }

}

class Tooltips extends Component {
  render() {
    return (
      <div className="tooltips-container">
        <ReactTooltip id="contact-tooltip" type="light" isCapture={true} className="contact-tooltip" place="bottom" event="click" effect="solid" >
          <div className="contact-tooltip-container">
            <div className="tooltip-email-message">
              email us:
            </div>
            <a href="mailto:hello@winno.app">
              <div className="tooltip-email-button">
                hello@winno.app
              </div>
            </a>
            {/* <div className="tooltip-social-buttons-container">
              <a href="https://twitter.com/usewinno" target="_blank">
                <div className="tooltip-twitter-button">
                  <i class="fab fa-twitter"></i>
                </div>
              </a>
              <a href="https://facebook.com/usewinno" target="_blank">
                <div className="tooltip-facebook-button">
                  <i class="fab fa-facebook-square"></i>
                </div>
              </a>
              <a href="https://reddit.com/r/winno" target="_blank">
                <div className="tooltip-reddit-button">
                  <i class="fab fa-reddit"></i>
                </div>
              </a>
            </div> */}
          </div>
        </ReactTooltip>
      </div>
    )
  }
}

class Nav extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_sticky: false,
      shrink_nav: false
    }
  }

  checkScroll() {
    // const { show_sticky, shrink_nav } = this.state
    // if (window.scrollY > 25) {
    //   !show_sticky && this.setState({ show_sticky: true })
    //   // ReactTooltip.rebuild()
    // } else {
    //   show_sticky && this.setState({ show_sticky: false })
    //   // ReactTooltip.rebuild()
    // }
    // if (window.scrollY > 160) {
    //   !shrink_nav && this.setState({ shrink_nav: true })
    // } else {
    //   shrink_nav && this.setState({ shrink_nav: false })
    // }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // if (this.state.show_sticky !== nextState.show_sticky || this.state.shrink_nav !== nextState.shrink_nav) {
    //   return true
    // }
  }

  componentDidMount() {
    // window.addEventListener('scroll', this.checkScroll.bind(this))
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.checkScroll.bind(this))
  }

  render() {
    let nav_container_class = this.state.shrink_nav ? "sticky-nav-inside-container shrink" : "sticky-nav-inside-container"
    return (
      <div className="top-nav-container">
        <div className="top-container">
          <div className="nav-container">
            <div className="logo-container">
              <img src={logo} className="logo-image" draggable="false" />
              <div className="logo-text">
                winno
              </div>
            </div>
            <div className="nav-right-container">
              {/*<NavLink to="/press" className="nav-button" activeClassName="nav-button-active">
                press
              </NavLink>*/}
              <div className="nav-labeled-buttons">
                <div className="nav-button nav-contact-button" data-for="contact-tooltip" data-tip="">
                  Contact
                </div>
                {/* <a href="#contribute">
                  <div className="nav-button">
                    join us
                  </div>
                </a> */}
                <a href="#manifesto">
                  <div className="nav-button">
                    Manifesto
                  </div>
                </a>
                {/* <a href="https://www.buymeacoffee.com/winno" target="_blank">
                  <div className="nav-button">
                    support us
                  </div>
                </a> */}
                <a href="#process">
                  <div className="nav-button">
                    About
                  </div>
                </a>
              </div>
              <div className="nav-button email-button" data-for="contact-tooltip" data-tip="">
                <i class="far fa-envelope"></i>
              </div>
              {/* <a href="https://twitter.com/usewinno" target="_blank">
                <div className="nav-button social-button">
                  <i class="fab fa-twitter"></i>
                </div>
              </a> */}
              {/*<div className="nav-button social-button">
                <i class="fab fa-facebook-square"></i>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class Header extends Component {

  render() {
    return (
      <div className="top-container">
        <div className="header-container">
          <div className="header-container-left">
            <div className="header-container-left-text">
              <div className="app-of-the-day-container">
                <a href="https://apps.apple.com/us/story/id1490613107" target="_blank">
                  <div className="app-of-the-day">
                    <i class="fas fa-star"></i>
                    App of the Day
                  </div>
                </a>
              </div>
              <div className="header-title">
                21st century news.
              </div>
              <div className="header-subtitle">
                Get key updates to stories you care about<br/>in one place, live. Written, curated and<br/>fact-checked by <span className="bold-text">humans</span>.
              </div>
              <div className="header-buttons-container">
                <a href="https://apps.apple.com/us/app/winno-just-the-facts/id1460212743?ls=1" target="_blank">
                  <div className="app-button-container">
                    <img src={app_store_button} className="app-store-button" draggable="false" />
                  </div>
                </a>
              </div>
              {/*<div className="video-label">
                <i class="fal fa-play-circle"></i>
                watch introduction video
              </div>*/}
              {/*<div className="app-button-container">
                <img src={app_store_button} className="app-store-button" draggable="false" />
                <img src={play_store_button} className="play-store-button" />
              </div>*/}
            </div>
          </div>
          <div className="header-container-right">
            <div className="screenshot-container">
              <img src={header_image} className="header-image" draggable="false" />
            </div>
          </div>
          <div className="header-container-bottom">
            <div className="mobile-screenshot-container">
              <img src={mobile_header_image} className="mobile-header-image" draggable="false" />
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class Ticker extends Component {

  constructor(props) {
    super(props)
    this.state = {
      feed_slugs: null
    }
  }

  componentDidMount() {
    fetch(BASE_API_URL + '/v1/feeds/active')
			.then(res => res.json())
			.then(data => {
				let feeds = data.feeds.map((feed) => {
          if (feed._id !== "5c589ef3b37fbc0004bcd318" && feed._id !== "5cbabb9458b81f0017db9bc7" && feed._id !== "5cbab65d58b81f0017db9ba6") {
            return (
              <FeedSlug name={feed.name} color={feed.color} />
            )
          }
				})
        this.setState({
          feed_slugs: feeds
        })
			})
  }

  render() {
    return (
      <div className="ticker-section-container">
        <div className="ticker-label">
          <i class="fas fa-arrow-down"></i>
          we're covering <span className="feeds-count">{this.state.feed_slugs && this.state.feed_slugs.length}</span> stories now
        </div>
        <div className="ticker-container">
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
        </div>
      </div>
    )
  }

}

class FutureTicker extends Component {

  constructor(props) {
    super(props)

    let future_feeds = [
      {
        name: "startups",
        color: "#FA8230"
      },
      {
        name: "oddities",
        color: "#7B99B8"
      },
      {
        name: "nature-photos",
        color: "#28994A"
      },
      {
        name: "entertainment",
        color: "#ffa502"
      },
      {
        name: "ny-yankees",
        color: "#132245"
      },
      {
        name: "tesla",
        color: "#C70000"
      },
      {
        name: "NFL",
        color: "#274194"
      },
      {
        name: "apple",
        color: "#cacaca"
      },
      {
        name: "warriors",
        color: "#0043A8"
      },
      {
        name: "yemen",
        color: "#222222"
      },
      {
        name: "san-francisco",
        color: "#B42010"
      },
      {
        name: "google",
        color: "#4280EF"
      },
      {
        name: "new-york",
        color: "#333333"
      },
      {
        name: "new-movies",
        color: "#EBBD2F"
      },
      {
        name: "driverless-cars",
        color: "#333333"
      }
    ]

    this.state = {
      raw_feed_slugs: future_feeds,
      feed_slugs: null
    }
  }

  componentDidMount() {
    let feeds = this.state.raw_feed_slugs.map((feed) => {
      return (
        <FeedSlug name={feed.name} color={feed.color} />
      )
    })
    this.setState({
      feed_slugs: feeds
    })
  }

  render() {
    return (
      <div className="future-ticker-section-container">
        <div className="ticker-label">
          <i class="fas fa-arrow-down"></i>
          some feeds we'd like to cover
        </div>
        <div className="ticker-container">
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
          {this.state.feed_slugs}
        </div>
      </div>
    )
  }

}

class FeedSlug extends Component {

  render() {
    return (
      <div className="slug-container" style={{backgroundColor: this.props.color}}>
        <i class="fas fa-hashtag"></i>
        {this.props.name}
      </div>
    )
  }

}

class Graphic extends Component {

  render() {
    return (
      <div className="graphic-section">
        <div className="section-title top-section-title">
          What we do
        </div>
        <div className="section-subtitle">
          The antidote to information overload.
        </div>
        <div className="graphic-container">
          <img src={graphic} className="graphic-image" draggable="false" />
        </div>
        <div className="mobile-graphic-container">
          <img src={mobile_graphic} className="mobile-graphic-image" draggable="false" />
        </div>
      </div>
    )
  }

}

class Darken extends Component {

  render() {
    return (
      <div className="darken-section">
        <div className="construction-container">
          <div className="logo-container">
            <img src={logo} className="logo-image" draggable="false" />
            <div className="logo-text">
              winno
            </div>
          </div>
          <div className="construction-title">We're under construction</div>
          <div className="construction-subtitle">Stay tuned for something new!</div>
          <div className="construction-contact"><a href="mailto:hello@winno.app">contact us</a></div>
        </div>
      </div>
    )
  }

}

// class Process extends Component {
//
//   render() {
//     return (
//       <div className="process-container" id="process">
//         <div className="section-title">
//           Our process
//         </div>
//         <div className="home-about-text">
//           <span className="about-number">1</span> Our experienced team tracks ongoing and breaking news stories 24/7<br/><br/>
//           <span className="about-number">2</span> We answer relevant questions in an FAQ to give you background and context<br/><br/>
//           <span className="about-number">3</span> When something happens, we post the facts: a summary, quote, tweet, image, or video<br/><br/>
//           <span className="about-number">4</span> We select one high-quality article or primary source for each update, so you can dive deeper<br/><br/>
//           <span className="about-number">5</span> When a story has concluded, we'll "archive" the feed and stop live coverage
//         </div>
//       </div>
//     )
//   }
//
// }

class Process extends Component {

  render() {
    return (
      <div className="process-container" id="process">
        <div className="section-title">
          Our process
        </div>
        <div className="screenshot-tiles-container">
          <div className="screenshot-tile">
            <img src={screenshot1} className="screenshot-tile-image" draggable="false" />
            <div className="tile-title">
              Live coverage
            </div>
            <div className="tile-subtitle">
              Our team creates a “feed” for ongoing or breaking news stories. One place to go for all the latest, best information.
            </div>
          </div>
          <div className="screenshot-tile">
            <img src={screenshot2} className="screenshot-tile-image" draggable="false" />
            <div className="tile-title">
              Just the facts
            </div>
            <div className="tile-subtitle">
              We post updates to the story, live. As short summaries, quotes, tweets, images, etc. Each with a link to read more.
            </div>
          </div>
          <div className="screenshot-tile">
            <img src={screenshot4} className="screenshot-tile-image" draggable="false" />
            <div className="tile-title">
              Get notified
            </div>
            <div className="tile-subtitle">
              Follow feeds to keep track of new updates and get notifications for breaking news. Customizable settings.
            </div>
          </div>
          <div className="screenshot-tile">
            <img src={screenshot3} className="screenshot-tile-image" draggable="false" />
            <div className="tile-title">
              Confused?
            </div>
            <div className="tile-subtitle">
              We answer FAQs to give you relevant background and context. You can submit questions to our team.
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class ShareRedirect extends Component {

  componentDidMount() {
    window.location.href = "sms:&body=You%27ll%20love%20this%20new%20app%20that%20makes%20it%20super%20easy%20to%20follow%20what%20matters%20in%20the%20news%3A%20https%3A%2F%2Fapple.co%2Fwinnosms:&body=You%27ll%20love%20this%20new%20app%20that%20makes%20it%20super%20easy%20to%20follow%20what%20matters%20in%20the%20news%3A%20https%3A%2F%2Fapple.co%2Fwinno";
  }

  render() {
    return (
      <div className="share-redirect">
      </div>
    )
  }

}

class Values extends Component {

  render() {
    return (
      <div className="values-container" id="values">
        <div className="section-title">
          Our values
        </div>
        <div className="info-tiles-container">
          <div className="info-tile tile-1">
            <div className="tile-icon-container">
              <i class="far fa-bullseye-arrow"></i>
            </div>
            <div className="tile-title">
              <div className="mobile-tile-icon-container">
                <i class="far fa-bullseye-arrow"></i>
              </div>
              Relevant
            </div>
            <div className="tile-subtitle">
              We only post relevant developments. Real, significant news only. No clickbait or fluff.
            </div>
          </div>
          <div className="info-tile tile-2">
            <div className="tile-icon-container">
              <i class="far fa-arrow-to-bottom"></i>
            </div>
            <div className="tile-title">
              <div className="mobile-tile-icon-container">
                <i class="far fa-arrow-to-bottom"></i>
              </div>
              Objective
            </div>
            <div className="tile-subtitle">
              We are focused on facts. No opinion. No commentary. Links to primary sources whenever available.
            </div>
          </div>
          <div className="info-tile tile-3">
            <div className="tile-icon-container">
              <i class="far fa-sun"></i>
            </div>
            <div className="tile-title">
              <div className="mobile-tile-icon-container">
                <i class="far fa-sun"></i>
              </div>
              Concise
            </div>
            <div className="tile-subtitle">
              We keep our updates brief and easy to understand. Often just one sentence.
            </div>
          </div>
          <div className="info-tile tile-4">
            <div className="tile-icon-container">
              <i class="far fa-atlas"></i>
            </div>
            <div className="tile-title">
              <div className="mobile-tile-icon-container">
                <i class="far fa-atlas"></i>
              </div>
              Complete
            </div>
            <div className="tile-subtitle">
              A feed is a comprehensive, definitive source for all the latest, best information. Period.
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class Reviews extends Component {

  render() {
    return (
      <div className="reviews-container" id="reviews">
        {/*<div className="section-title reviews-section-title">
          What users say
        </div>*/}
        <div className="review-item">
          <div className="review-text">
          I can finally consume news! This is the first time I’ve ever felt compelled to leave a review for an app.  I had gotten to the point in life where I was avoiding news all together because it all seemed so sensational.  But I felt just as cruddy being out of touch.  I downloaded this when it was the featured app of the day and since then, my life has literally been changed.  Being able to stay up to date without the mental strain of sorting through sensationalist opinions is a game changer.  This is the future of news.  Mainstream news takes energy to consume.  This gives energy.  Please keep this app going.  I would happily pay for more categories.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Sonicheroguys
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          This is my first review on the App Store after holding an iPhone as a consumer for over ten years. If I could rate this app higher, I would. I get most of my headlines and alerts from Winno, and it truly is a fantastic resource for anyone interested in keeping up with breaking news. Keep up the great work!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Mr. Review Master
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Top notch news app - really innovative. I love this news app so much. This is the first news app I’ve seen in awhile that really brings along something truly fresh and unique. The bite-sized presentation of facts is perfect for staying up on key bits of information without click-baity or misleading headlines. I have high hopes for this app and would love to see it grow bigger.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              fyreous
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          I never give reviews, but I have to give a review for Winno because it is a life-changer for me. I had a problem with keeping up with news because I have crazy hours... before I started using Winno. The information is succinct and perfectly summarized in a flow, with key terms often explained in its call-out box. It is extremely useful to flow on specific topics, and I love this information efficiency.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              PearlyOrchid
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          FINALLY, I can clear my head! I ran across this app after seeing it on a YouTube video. I LOVE IT and it is my new favorite app. I spend hours and hours quarantined listening to one piece of bad news after another...with a different opinion on each channel. But now, I can read a 2-3 sentence personalized 'non-biased blurb' and feel that I have been informed OR I can go on and read the entire article...my choice. I have not watched cable news since I bought the app and my stress level has gone down but my knowledge level has gone up. Thanks, we all needed this!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Rstrick41
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Best news app in the store. My favorite and most used app. It’s like a personal assistant that keeps you up to speed with what’s going on. You get the facts at a glance and good sources to dig deeper. Most amazingly it’s pretty unbiased.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              ducdybcdgbc
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Perfect app. I’m not someone who has time (or the interest) to search multiple news outlets to get my information, so before Winno I barely kept up to date with the news. This app makes it so easy to follow topics that interest you in tiny doses which you can easily read about through the in-app links to the sources. I also love the #history-photos feed it’s great.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              JennaVC
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Hands down the best way to consume the news. I'm sick and tired of all these garbage news apps using AI to recommend me articles just so I click on them and they make a profit. I love that with Winno I don't have to deal with any clickbait titles or scroll through an entire article just to realize it's a bunch of fluff. The focused categories are great for when I want to follow a single developing news story and not worry about everything going on in a topic as broad as Politics, for example. This app is like the best parts of Axios + Twitter + traditional news combined.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              37473828477
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Often people speak about information overload in an era where there is information everywhere and where information tends to be overwhelming. This app does a brilliant job of making current events both easy to keep up with and save yourself time while doing so. I will never use another news app.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Garbage, TJ
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          It's so good! First of all it’s live news! And it’s like the best news app ever found! Its greatness cannot be explained in words. Definitely a must have.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              SlothGurl
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            The future of news consumption. I highly recommend Winno. It's so easy to customize your feed to your liking. I love being able to follow up on important topics like climate change and trump-probes with confidence, knowing the articles on here are 100% real and not BS fear mongering. If you're looking for a way to break out of the Fox News / CNN clown show, please check out Winno! It is truly the future of news!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Sean11420
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Short review: So good I want to pay money for it! Long review:  Winno checks all the boxes for good news as well as good software: Clear, Organized, Factual, Non-Partisan, and doesn't require too much personal data.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              GödelEscherBach
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          This news source is my all-time favorite. I’ve never run into one that isn’t clouded by so much bias and political leanings. It’s so refreshing and enlightening to simply experience factual headlines coming in.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              classact52
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Quality news without the spam. Winno delivers enough news for me to feel like I know what’s going on in the world, without being inundated with more information than I know what to do with. Winno respects my time by taking up as little of my time as possible, while maximizing the value of the small amount of time it does consume.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Ghostfly48
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Super helpful for staying informed! Wow! SUCH a well thought out app. The layout on iPad feels like a modified layout of the iPhone version, but that very minor thought is COMPLETELY outweighed by how helpful this app is for me staying informed, and I cannot over state how valuable it is that this developer has clearly thought about their users and made decisions out of consideration for their users.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              mchisolm0
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            This has been my go-to app for getting news fast. It's extremely convenient to read the well-put-together sound bites and decide, thereafter, whether to read the associated article or not. Frankly, the idea of this app is brilliant.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              SKBlank
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Winno sets the standard against which all news-feed apps will forever be judged.  Hands-down the best app out there for customizing a feed that is bias-free and uniquely your own.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Chrisanneiam
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Usually don't review, but want to show appreciation. This app perfectly suits my needs as a consumer who wants unbiased and quickly-summarized news. It's free, has a simple and attractive UI, and streamlines all the important headlines you want to read. I recommend this to all my peers and would even pay money for it if I needed to. Heck, I'd probably even donate just to help support the team.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              jmwalker0498
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            The editorial team does an awesome job at only showing “just the facts”. With all the opinion heavy nonsense in the news today, I've been looking for a way to stay updated without all the bias. This is it. The interface is well designed, the app is really well coded, the content is of good quality, and I appreciate the links to read more ... Look forward to reading more.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Habit Builder
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          This is the best compilation of real news stories I have seen. I pick the subjects and am delivered a carefully curated set of the latest articles from trusted sources I could imagine. Thank you, whoever is behind this!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              ntf375$.com
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Best news app out there no doubt. Not biased, easy comprehension, perfectly curated notification. Bravo guys!!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              TolucoMan
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          Best way to start the news day. I have a bunch of news apps that I love, but I always start the day with Winno because it is succinct, focused and unbiased. Highly recommended.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              eastoneddie
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Clear and concise! Easy to digest snippets of news that are clear to understand. Won't bombard you with notifications. This is what I want as a daily source of information and I don't know what else to ask for.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              BlairZ-21
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          I wanted to share with you how much I love this app and how life changing it has been. This app has helped many students my age stay informed. I cannot say enough good things. Thank you to everyone that has contributed to this app!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              Amy M.
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
          The solution to news on social media. I love this app. It has succinct, current stories and the feed feature is neat and convenient. A nice alternative to getting news through social media, which is full of commentary and misinformation. Like a Brita for news!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              pfgaggvl
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            New favorite app. Hats off to the developers who created this beautiful app. It's designed to give you quick and fact-based summaries so you're not constantly inundated with tons of irrelevant headlines and stories. You pick the topics you want to follow and they quietly deliver summaries to your iPhone or iPad.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              mattpetermann
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Good concept, even better implementation. So first off, this app is pretty amazing. From the way it implements Sign In with Apple to the way it categorizes feeds. And then the concise pop up links. Great job guys.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              srtRish
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Perfect news app. This app is perfect for getting short little paragraphs of important news. They make it so easy to find topics and get the most relevant information in that topic ... I love this app because I can get just enough to be informed, and it helps me figure out what's going on in the world without being super confused!
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              ssheaaaaa
            </div>
          </div>
        </div>
        <div className="review-item">
          <div className="review-text">
            Seriously the best. Fantastic UI and only the factual news. This is the only news app left on my phone now.
          </div>
          <div className="review-item-bottom">
            <div className="review-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
            <div className="review-username">
              shiverlay
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class Contribute extends Component {

  render() {
    return (
      <div className="contribute-container" id="contribute">
        <div className="section-title">
          Join us
        </div>
        <div className="contribute-subtitle">
          Join our Discord community to discuss current events and chat with the team. Want to contribute? <a href="mailto:hello@winno.app">Send an email.</a> We're hiring full and part-time curators.
        </div>
        <a href="https://discord.gg/3QfXrfG" target="_blank">
          <div className="slack-button">
            {/*<i class="fab fa-slack-hash"></i>*/}
            <div className="slack-button-label">
              join our
            </div>
            <img src={discord} className="discord-logo" />
          </div>
        </a>
      </div>
    )
  }

}

class Manifesto extends Component {

  render() {
    return (
      <div className="manifesto-section" id="manifesto">
        <div className="section-title">
          Our manifesto
        </div>
        <div className="manifesto-container">
          <span className="manifesto-title">
            We want to help people understand the world better.
          </span>
          <div className="manifesto-text">

            News is broken. Surveys show a large majority of Americans feel overwhelmed by the news and the vast amount of information online. What important things happened today? This question should be easy to answer in the 21st century. It is not.<br/><br/>

            We're spoon-fed junk. We scroll mindlessly through feeds of endless content, filtered through algorithms, where the line between fact and opinion is blurred. No flow, no structure, no chronology. Just a bunch of unfocused noise and shrill voices. We're left piecing together stories on our own.<br/><br/>

            Not anymore. We're rebuilding news from the ground up, for the internet era.<br/><br/>

            Winno is an app where you can get all the important updates to a story in one place, live. Both fast-paced breaking news and slower developing stories alike. We don't post links or headlines; we condense a development into its core components and post just the facts. Curated, written and fact-checked by our team. We give you everything you need to know, without the noise.<br/><br/>

            By shrinking the unit of news from article to fact, we can present primary sources and quotes without opinion mixed in. It lets us comprehensively cover a story in real-time and be clear, engaging and objective. And because our approach is disciplined and feeds are finite, Winno lets people feel 100% up-to-date at the end of the day. Not like there's always more to wade through.<br/><br/>

            Because we've built a self-contained product, we don't need to publish rubbish to attract clicks on third-party platforms. We can focus instead on creating the best resource for timely, relevant, truthful information. Just the stuff that matters. No bullshit.<br/><br/>

            We are committed to building a humane, attention-friendly experience. Unlike other news outlets, we give users the power to choose which stories to follow and get notifications about. Our goal is to create a healthy product that people love, and we will ensure that our incentives as a business always align.<br/>

          </div>
          {/*<a href="mailto:beta@winno.app">
            <div className="header-button">
              join the beta
            </div>
          </a>*/}
        </div>
      </div>
    )
  }

}

class Browse extends Component {

  constructor(props) {
    super(props)
    this.state = {
      feed_tiles: null,
      loading: true
    }
  }

  componentDidMount() {
    fetch(BASE_API_URL + '/v1/feeds/active')
			.then(res => res.json())
			.then(data => {
				let feeds = data.feeds.map((feed) => {
          if (feed.name !== "test-feed" && feed.name !== "tutorial") {
            return (
              <FeedTile id={feed._id} name={feed.name} color={feed.color} description={feed.description} updated_at={feed.updated_at} num_followers={feed.num_followers} num_updates={feed.num_updates} image_url={feed.image_url} />
            )
          }
				})
        this.setState({
          feed_tiles: feeds,
          loading: false
        })
			})
  }

  render() {
    return (
      <div className="browse-container">
        <div className="test-container">
          {this.state.loading &&
            <div className="loading-container">
              <ClipLoader
                className="loading-spinner"
                sizeUnit={"px"}
                size={150}
                color={'#999999'}
                loading={this.state.loading}
              />
            </div>
          }
          <div className="tiles-container">
            {this.state.feed_tiles}
            {this.state.feed_tiles}
          </div>
        </div>
      </div>
    )
  }

}

class Tutorial extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className="tutorial-container">
        <div className="tutorial-header">Woo!</div>
        <div className="tutorial-text">This will be a hand-selected article or primary source. A short summary isn't always enough, so we give you the chance to dive deeper.</div>
      </div>
    )
  }

}

class Farewell extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className="farewell-container">
        <img src={farewell_logo} className="farewell-logo" />
        <p className="farewell-paragraph">Hello Winno readers –</p>
        <p className="farewell-paragraph">We'd like to share some updates about the future of this app.</p>
        <p className="farewell-paragraph">We launched the first version of Winno in late 2019 with the goal of creating the fastest and easiest way to stay on top of news, without spin or clickbait. Driven by this mission, our team has worked tirelessly behind the scenes to make this possible. We grew to thousands of regular readers and were honored as "App of the Day" twice. We've covered important events like the Covid-19 pandemic, the 2020 election and its aftermath, the war in Ukraine and more. And we've done this for free: Winno has never earned a cent from advertising or subscriptions.</p>
        <p className="farewell-paragraph">The unfortunate truth is that this is not sustainable. From the very start, our mission has been to build a product that helps people understand the world better. We hoped we'd find a way to make this product financially viable without sacrificing our mission and our commitment to respecting users' attention and privacy. Despite our efforts and your support, we have not found such a way.</p>
        <p className="farewell-paragraph">We're sad to announce that we have suspended our news coverage and removed the Winno app from the App Store. However, this is not the end of Winno as a company: we are working on exciting new products and remain committed to building a space for better, factual news.</p>
        <p className="farewell-paragraph">Thank you for sticking with us and believing in our mission – we've worked hard to make this possible, and your love and support has kept us energized.</p>
        <p className="farewell-paragraph">We would love to stay in touch and have you be the first to know about our future plans. Please <a href="https://docs.google.com/forms/d/e/1FAIpQLSc5Ih8Fxl82hQB8ubcA8ad4_5fSMkFhEfLJsR4Mz218pJxxHw/viewform?usp=sf_link">click here</a> to share your email and optional comments.</p>
        <p className="contribute-ps"><span className="farewell-name">Nick Rubin</span><br/>Founder & Editor<br/><br/><a href="https://twitter.com/nickrubin">Twitter</a><br/><a href="mailto:nick@winno.app">Email</a></p>
      </div>
    )
  }

}

class Support extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_crypto: false
    }
  }

  copy(n) {
    if (n === 1) {
      var btc = document.getElementById("btc-address");
      btc.select();
      document.execCommand('copy');
      alert("Copied to clipboard.");
    } else if (n === 2) {
      var btc = document.getElementById("eth-address");
      btc.select();
      document.execCommand('copy');
      alert("Copied to clipboard.");
    }
  }

  render() {
    return (
      <div>
        {!this.state.show_crypto &&
          <div className="donate-container">
            <a href="https://www.buymeacoffee.com/winno">
              <div className="contribute-main-button">Tap to support us</div>
            </a>
            <div className="contribute-crypto-button" onClick={() => this.setState({show_crypto: true})}>or tap here for crypto</div>
            <p className="contribute-text">Winno launched in late 2019 with the goal of creating the fastest and easiest way to stay on top of news. Since then, we have been featured as Apple's "App of the Day" twice and expanded coverage to over 30 topics without ads or charging a dime.</p>
            <p className="contribute-paragraph">That's because at Winno we believe that factual information should be free and accessible to everyone, not hidden behind expensive paywalls.</p>
            <p className="contribute-paragraph">We are launching a <a href="https://www.buymeacoffee.com/winno">Buy Me a Coffee</a> page to help us continue our mission and expand our coverage. While we do not plan to permanently rely on this for funding, your support will enable us to expand our product beyond our current limits. We have a ton of ideas in the pipeline: new local feeds, coverage of Europe, a #movies feed, new app features, and much more. With your support, Winno can continue our mission of creating fact-based, time-saving news.</p>
            <img src={full_logo} className="donate-logo" />
            <p className="contribute-ps">PS: If you have any questions, shoot us an email at <a href="mailto:hello@winno.app">hello@winno.app.</a></p>
          </div>
        }
        {this.state.show_crypto &&
          <div>
            <div className="donate-back-button" onClick={() => this.setState({show_crypto: false})}><i class="fas fa-arrow-left"></i> Back</div>
            <div className="donate-container">
              <div className="crypto-label">Bitcoin</div>
              <input type="text" readOnly={true} className="crypto-address" id="btc-address" onClick={() => this.copy(1)} value="bc1qkaf4eper86vw42h7u39pa0lzk4jn3s73fhjprl" />
              <div className="copy-label"><i class="fas fa-arrow-up"></i>tap to copy</div>
              <img src={bitcoin_qr} className="crypto-qr" />
              <div className="crypto-label">Ethereum</div>
              <input type="text" readOnly={true} className="crypto-address" id="eth-address" onClick={() => this.copy(2)} value="0xDEa9d01f19b9f92Bf1BDa60977E8aAdD5b5482E6" />
              <div className="copy-label"><i class="fas fa-arrow-up"></i>tap to copy</div>
              <img src={ethereum_qr} className="crypto-qr" />
            </div>
          </div>
        }
      </div>
    )
  }

}

class Legal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_state: 0
    }
  }

  selectTerms() {
    this.setState({
      show_state: 0
    })
  }

  selectPrivacy() {
    this.setState({
      show_state: 1
    })
  }

  selectLicenses() {
    this.setState({
      show_state: 2
    })
  }

  render() {
    return (
      <div className="legal-page-container">
        <div className="legal-buttons-container">
          <div className={this.state.show_state === 0 ? "legal-button selected-legal-button" : "legal-button legal-left"} onClick={this.selectTerms.bind(this)}>
            <div className="legal-button-text">
              terms
            </div>
          </div>
          <div className={this.state.show_state === 1 ? "legal-button selected-legal-button" : "legal-button legal-right"} onClick={this.selectPrivacy.bind(this)}>
            <div className="legal-button-text">
              privacy
            </div>
          </div>
          <div className={this.state.show_state === 2 ? "legal-button legal-right selected-legal-button" : "legal-button legal-right"} onClick={this.selectLicenses.bind(this)}>
            <div className="legal-button-text">
              licenses
            </div>
          </div>
        </div>
        {this.state.show_state === 0 &&
          <Terms />
        }
        {this.state.show_state === 1 &&
          <Privacy />
        }
        {this.state.show_state === 2 &&
          <Licenses />
        }
      </div>
    )
  }

}

class Terms extends Component {

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="legal-container">
        <img className="legal-logo" src={legal_logo}/>
        <h2 className="legal-title">Terms of Service</h2>
        <div>Last updated: 7/5/2019</div><br/>
        <div>
          These Terms of Service (“<span className="bold-legal-text">Terms</span>”) apply to your access to and use of the websites, mobile applications and other online products and services (collectively, the “<span className="bold-legal-text">Services</span>”) provided by Winno, Inc. (“<span className="bold-legal-text">Winno</span>” or “<span className="bold-legal-text">we</span>”). <span className="bold-legal-text">By using our Services, you agree to these Terms, including the mandatory arbitration provision and class action waiver in Section 13. If you do not agree to these Terms, do not use our Services.</span><br/><br/>
          We may make changes to these Terms from time to time. If we make changes, we will provide you with notice of such changes, such as by sending an email, providing a notice through our Services or updating the date at the top of these Terms. Unless we say otherwise in our notice, the amended Terms will be effective immediately, and your continued use of our Services after we provide such notice will confirm your acceptance of the changes. If you do not agree to the amended Terms, you must stop using our Services.<br/><br/>
          If you have any questions about these Terms or our Services, please contact us at <a href="mailto:legal@winno.app">legal@winno.app</a>.<br/><br/>
          For information about how we collect, use, share or otherwise process information about you, please see our Privacy Policy: <a href="https://winno.app/privacy" target="_blank">https://winno.app/privacy</a>.
        </div>
        <h3 className="legal-subtitle">1. Eligibility</h3>
        <div>
          You must be at least 18 years of age to use our Services. If you use our Services on behalf of another person or entity, (a) all references to “you” throughout these Terms will include that person or entity, (b) you represent that you are authorized to accept these Terms on that person's or entity's behalf, and (c) in the event you or the person or entity violates these Terms, the person or entity agrees to be responsible to us.
        </div>
        <h3 className="legal-subtitle">2. User Accounts and Account Security</h3>
        <div>
          You may need to register for an account to access some or all of our Services. If you register for an account, you must provide accurate account information and promptly update this information if it changes. You also must maintain the security of your account and promptly notify us if you discover or suspect that someone has accessed your account without your permission. If you permit others to use your account credentials, you are responsible for the activities of such users that occur in connection with your account. We reserve the right to reclaim usernames, including on behalf of businesses or individuals that hold legal claim, including trademark rights, in those usernames.
        </div>
        <h3 className="legal-subtitle">3. Prohibited Conduct</h3>
        <div>
          You will not violate any applicable law, contract, intellectual property right or other third-party right or commit a tort, and you are solely responsible for your conduct while using our Services. You will not:
          <ul>
            <li>Engage in any harassing, threatening, intimidating, predatory or stalking conduct;</li><br/>
            <li>Use or attempt to use another user's account without authorization from that user and Winno;</li><br/>
            <li>Impersonate any person or entity or otherwise misrepresent your affiliation with a person or entity;</li><br/>
            <li>Sell, resell or commercially use our Services;</li><br/>
            <li>Copy, reproduce, distribute, publicly perform or publicly display all or portions of our Services, except as expressly permitted by us or our licensors;</li><br/>
            <li>Modify our Services, remove any proprietary rights notices or markings, or otherwise make any derivative works based upon our Services;</li><br/>
            <li>Use our Services other than for their intended purpose and in any manner that could interfere with, disrupt, negatively affect or inhibit other users from fully enjoying our Services or that could damage, disable, overburden or impair the functioning of our Services in any manner;</li><br/>
            <li>Reverse engineer any aspect of our Services or do anything that might discover source code or bypass or circumvent measures employed to prevent or limit access to any part of our Services;</li><br/>
            <li>Attempt to circumvent any content-filtering techniques we employ or attempt to access any feature or area of our Services that you are not authorized to access;</li><br/>
            <li>Use any data mining, robots or similar data gathering or extraction methods designed to scrape or extract data from our Services;</li><br/>
            <li>Develop or use any applications that interact with our Services without our prior written consent;</li><br/>
            <li>Bypass or ignore instructions contained in our robots.txt file; or</li><br/>
            <li>Use our Services for any illegal or unauthorized purpose, or engage in, encourage or promote any activity that violates these Terms.</li>
          </ul>
          Enforcement of this Section 3 is solely at Winno's discretion, and failure to enforce this section in some instances does not constitute a waiver of our right to enforce it in other instances.  In addition, this Section 3 does not create any private right of action on the part of any third party or any reasonable expectation that the Services will not contain any content that is prohibited by such rules.
        </div>
        <h3 className="legal-subtitle">4. Ownership; Limited License</h3>
        <div>
          The Services, including the text, graphics, images, photographs, videos, illustrations, curated news content, and other content contained therein, are owned by Winno, or our licensors, third parties with whom we have a relationship, and other third parties, and are protected under both United States and foreign laws. Except as explicitly stated in these Terms, all rights in and to the Services are reserved by us or our licensors. Subject to your compliance with these Terms, you are hereby granted a limited, nonexclusive, nontransferable, non-sublicensable, revocable license to access and use our Services for your own personal, noncommercial use. Any use of the Services other than as specifically authorized herein, without our prior written permission, is strictly prohibited, will terminate the license granted herein and violate our intellectual property rights.
        </div>
        <h3 className="legal-subtitle">5. Trademarks</h3>
        <div>
          WINNO and our logos, our product or service names, our slogans and the look and feel of the Services are trademarks of Winno and may not be copied, imitated or used, in whole or in part, without our prior written permission. All other trademarks, registered trademarks, product names and company names or logos mentioned on the Services are the property of their respective owners. Reference to any products, services, processes or other information by trade name, trademark, manufacturer, supplier or otherwise does not constitute or imply endorsement, sponsorship or recommendation by us.
        </div>
        <h3 className="legal-subtitle">6. Feedback</h3>
        <div>
          You may voluntarily post, submit or otherwise communicate to us any questions, comments, suggestions, ideas, original or creative materials or other information about Winno or our Services (collectively, “<span className="bold-legal-text">Feedback</span>”). You understand that we may use such Feedback for any purpose, commercial or otherwise, without acknowledgment or compensation to you, including, without limitation, to develop, copy, publish, or improve the Feedback in Winno's sole discretion. You understand that Winno may treat Feedback as nonconfidential.
        </div>
        <h3 className="legal-subtitle">7. Third-Party Content</h3>
        <div>
          We may provide information about third-party products, services, activities, events, news stories, and opinions, or we may allow third parties to make their content and information available on or through the Services (collectively, “<span className="bold-legal-text">Third-Party Content</span>”). We provide, curate, and make available, Third-Party Content as a service to those interested in such content. Your dealings with, interpretations of, or correspondence with such third parties and your use of or interaction with any Third-Party Content are solely between you and the third party. Winno does not control or endorse, and makes no representations or warranties regarding, any Third-Party Content, and your access to and use of such Third-Party Content is at your own risk.
        </div>
        <h3 className="legal-subtitle">8. Indemnification</h3>
        <div>
          To the fullest extent permitted by applicable law, you will indemnify, defend and hold harmless Winno and our officers, directors, agents, partners and employees (individually and collectively, the “<span className="bold-legal-text">Winno Parties</span>”) from and against any losses, liabilities, claims, demands, damages, expenses or costs (“<span className="bold-legal-text">Claims</span>”) arising out of or related to (a) your access to or use of the Services; (b) your Feedback; (c) your violation of these Terms; (d) your violation, misappropriation or infringement of any rights of another (including intellectual property rights or privacy rights); or (e) your conduct in connection with the Services. You agree to promptly notify Winno Parties of any third-party Claims, cooperate with Winno Parties in defending such Claims and pay all fees, costs and expenses associated with defending such Claims (including, but not limited to, attorneys' fees). You also agree that the Winno Parties will have control of the defense or settlement, at Winno's sole option, of any third-party Claims. This indemnity is in addition to, and not in lieu of, any other indemnities set forth in a written agreement between you and Winno or the other Winno Parties.
        </div>
        <h3 className="legal-subtitle">9. DMCA Policy</h3>
        <div>
          Winno respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998, Winno will respond expeditiously to claims of copyright infringement committed using the Services.<br/><br/>
          If you are a copyright owner, authorized to act on behalf of one, or authorized to act under any exclusive right under copyright, please report alleged copyright infringement taking place on our Services by sending a Notice to Winno's Designated Agent as identified below. After we receive a valid and complete Notice, we will investigate and remove the material if deemed appropriate. The notice must include the following:<br/><br/>
          <ol>
            <li>Identify the copyrighted work that you claim has been infringed, or – if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted work that you claim have been infringed.</li><br/>
            <li>Identify the material or link you claim is infringing (or the subject of infringing activity) and to which access is to be disabled, including at a minimum, the exact location where such material may be found.</li><br/>
            <li>Provide your company affiliation (if applicable), mailing address, telephone number and email address.</li><br/>
            <li>Include both of the following statements in the body of the Notice:<br/>
              <ul>
                <li>“I hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorized by the copyright owner, its agent, or the law (e.g. as a fair use)”</li><br/>
                <li>"I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of, the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.”</li>
              </ul>
            </li><br/>
            <li>Provide your full legal name and your electronic or physical signature.</li><br/>
          </ol>
          Copyright Agent<br/>
          584 Castro St #2028<br/>
          San Francisco, CA 94114<br/>
          <a href="mailto:legal@winno.app">legal@winno.app</a>
        </div>
        <h3 className="legal-subtitle">10. Disclaimers</h3>
        <div className="legal-section bold-legal-text">
          Your use of our Services is at your sole risk. Except as otherwise provided in a writing by us, our Services and any content therein are provided “as is” and “as available” without warranties of any kind, either express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement. In addition, Winno does not represent or warrant that our Services are accurate, complete, reliable, current or error-free. While Winno attempts to make your use of our Services and any content therein safe, we cannot and do not represent or warrant that our Services or servers are free of viruses or other harmful components. You assume the entire risk as to the quality and performance of the Services.
        </div>
        <h3 className="legal-subtitle">11. Limitation of Liability</h3>
        <div className="legal-section bold-legal-text">
          To the fullest extent permitted by applicable law, Winno and the other Winno Parties will not be liable to you under any theory of liability—whether based in contract, tort, negligence, warranty, or otherwise—for any indirect, consequential, incidental, or special damages or lost profits, even if Winno or the other Winno Parties have been advised of the possibility of such damages.<br/><br/>
          The total liability of Winno and the other Winno Parties for any claim arising out of or relating to these Terms or our Services, regardless of the form of the action, is limited to $10.00.<br/><br/>
          The limitations set forth in this Section 10 will not limit or exclude liability for the gross negligence, fraud or intentional misconduct of Winno or the other Winno Parties or for any other matters in which liability cannot be excluded or limited under applicable law. Additionally, some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitations or exclusions may not apply to you.
        </div>
        <h3 className="legal-subtitle">12. Release</h3>
        <div>
          To the fullest extent permitted by applicable law, you release Winno and the other Winno Parties from responsibility, liability, claims, demands and/or damages (actual and consequential) of every kind and nature, known and unknown (including, but not limited to, claims of negligence), arising out of or related to disputes between users and the acts or omissions of third parties. If you are a consumer who resides in California, you hereby waive your rights under California Civil Code § 1542, which provides: “A general release does not extend to claims which the creditor or releasing party does not know or suspect to exist in his or her favor at the time of executing the release, which if known by him or her, would have materially affected his or her settlement with the debtor or released party.”
        </div>
        <h3 className="legal-subtitle">13. Transfer and Processing Data</h3>
        <div>
          In order for us to provide our Services, you agree that we may process, transfer and store information about you in the United States and other countries, where you may not have the same rights and protections as you do under local law.
        </div>
        <h3 className="legal-subtitle">14.	Dispute Resolution; Binding Arbitration</h3>
        <div>
          <span className="bold-legal-text">Please read the following section carefully because it requires you to arbitrate certain disputes and claims with Winno and limits the manner in which you can seek relief from us, unless you opt out of arbitration by following the instructions set forth below. No class or representative actions or arbitrations are allowed under this arbitration agreement. In addition, arbitration precludes you from suing in court or having a jury trial.<br/><br/>
          No Representative Actions. You and Winno agree that any dispute arising out of or related to these Terms or our Services is personal to you and Winno and that any dispute will be resolved solely through individual action, and will not be brought as a class arbitration, class action or any other type of representative proceeding.</span><br/><br/>
          <span className="bold-legal-text">Arbitration of Disputes.</span> Except for small claims disputes in which you or Winno seeks to bring an individual action in small claims court located in the county of your billing address or disputes in which you or Winno seeks injunctive or other equitable relief for the alleged unlawful use of intellectual property, <span className="bold-legal-text">you and Winno waive your rights to a jury trial and to have any dispute arising out of or related to these Terms or our Services resolved in court.</span> Instead, for any dispute or claim that you have against Winno or relating in any way to the Services, including privacy and data security claims, you agree to first contact Winno and attempt to resolve the claim informally by sending a written notice of your claim (“<span className="bold-legal-text">Notice</span>”) to Winno by email at legal@winno.app or by certified mail addressed to Winno, Inc., 584 Castro St #2028, San Francisco, CA 94114. The Notice must (a) include your name, residence address, email address, and telephone number; (b) describe the nature and basis of the claim; and (c) set forth the specific relief sought. Our notice to you will be similar in form to that described above. If you and Winno cannot reach an agreement to resolve the claim within thirty (30) days after such Notice is received, then either party may submit the dispute to binding arbitration administered by JAMS or, under the limited circumstances set forth above, in court. All disputes submitted to JAMS will be resolved through confidential, binding arbitration before one arbitrator. Arbitration proceedings will be held in San Francisco County, CA or may be conducted telephonically or via video conference for disputes alleging damages less than $10,000.00, in accordance with the JAMS Streamlined Arbitration Rules and Procedures (“<span className="bold-legal-text">JAMS Rules</span>”). The most recent version of the JAMS Rules are available on the JAMS website and are hereby incorporated by reference. You either acknowledge and agree that you have read and understand the JAMS Rules or waive your opportunity to read the JAMS Rules and waive any claim that the JAMS Rules are unfair or should not apply for any reason.<br/><br/>
          You and Winno agree that these Terms affect interstate commerce and that the enforceability of this Section 13 will be substantively and procedurally governed by the Federal Arbitration Act, 9 U.S.C. § 1, et seq. (the “<span className="bold-legal-text">FAA</span>”), to the maximum extent permitted by applicable law. As limited by the FAA, these Terms and the JAMS Rules, the arbitrator will have exclusive authority to make all procedural and substantive decisions regarding any dispute and to grant any remedy that would otherwise be available in court, including the power to determine the question of arbitrability. The arbitrator may conduct only an individual arbitration and may not consolidate more than one individual's claims, preside over any type of class or representative proceeding or preside over any proceeding involving more than one individual.<br/><br/>
          The arbitrator, Winno, and you will maintain the confidentiality of any arbitration proceedings, judgments and awards, including, but not limited to, all information gathered, prepared and presented for purposes of the arbitration or related to the dispute(s) therein. The arbitrator will have the authority to make appropriate rulings to safeguard confidentiality, unless the law provides to the contrary. The duty of confidentiality does not apply to the extent that disclosure is necessary to prepare for or conduct the arbitration hearing on the merits, in connection with a court application for a preliminary remedy or in connection with a judicial challenge to an arbitration award or its enforcement, or to the extent that disclosure is otherwise required by law or judicial decision.<br/><br/>
          You and Winno agree that for any arbitration you initiate, you will pay the filing fee and Winno will pay the remaining JAMS fees and costs. For any arbitration initiated by Company, Winno will pay all JAMS fees and costs. You and Winno agree that the state or federal courts of the State of California and the United States sitting in San Francisco County, CA have exclusive jurisdiction over any appeals and the enforcement of an arbitration award.<br/><br/>
          <span className="bold-legal-text">Any claim arising out of or related to these Terms or our Services must be filed within one year after such claim arose; otherwise, the claim is permanently barred, which means that you and Winno will not have the right to assert the claim.</span><br/><br/>
          <span className="bold-legal-text">You have the right to opt out of binding arbitration within 30 days of the date you first accepted the terms of this Section 13 by emailing us at legal@winno.app with the subject line “arbitration opt-out.”</span> In order to be effective, the opt-out notice must include your full name and address and clearly indicate your intent to opt out of binding arbitration. By opting out of binding arbitration, you are agreeing to resolve disputes in accordance with Section 14.<br/><br/>
          If any portion of this Section 13 is found to be unenforceable or unlawful for any reason, (a) the unenforceable or unlawful provision shall be severed from these Terms; (b) severance of the unenforceable or unlawful provision shall have no impact whatsoever on the remainder of this Section 13 or the parties' ability to compel arbitration of any remaining claims on an individual basis pursuant to this Section 13; and (c) to the extent that any claims must therefore proceed on a class, collective, consolidated, or representative basis, such claims must be litigated in a civil court of competent jurisdiction and not in arbitration, and the parties agree that litigation of those claims shall be stayed pending the outcome of any individual claims in arbitration. Further, if any part of this Section 13 is found to prohibit an individual claim seeking public injunctive relief, that provision will have no effect to the extent such relief is allowed to be sought out of arbitration, and the remainder of this Section 13 will be enforceable.
        </div>
        <h3 className="legal-subtitle">15. Governing Law and Venue</h3>
        <div>
          Any dispute arising from these Terms and your use of the Services will be governed by and construed and enforced in accordance with the laws of California, except to the extent preempted by U.S. federal law, without regard to conflict of law rules or principles (whether of California or any other jurisdiction) that would cause the application of the laws of any other jurisdiction. Any dispute between the parties that is not subject to arbitration or cannot be heard in small claims court will be resolved in the state or federal courts of California and the United States, respectively, sitting in San Francisco County, CA.
        </div>
        <h3 className="legal-subtitle">16. Modifying and Terminating our Services</h3>
        <div>
          We reserve the right to modify our Services or to suspend or stop providing all or portions of our Services at any time. You also have the right to stop using our Services at any time. We are not responsible for any loss or harm related to your inability to access or use our Services.
        </div>
        <h3 className="legal-subtitle">17. Severability</h3>
        <div>
          If any provision or part of a provision of these Terms is unlawful, void or unenforceable, that provision or part of the provision is deemed severable from these Terms and does not affect the validity and enforceability of any remaining provisions.
        </div>
        <h3 className="legal-subtitle">18. Additional Terms Applicable to Mobile Devices</h3>
        <div>
          The following terms apply if you install, access or use the Services on any device that contains the iOS mobile operating system (the “<span className="bold-legal-text">iOS App</span>”) developed by Apple Inc. (“<span className="bold-legal-text">Apple</span>”).
          <ul>
            <li><span className="legal-underline-text">Acknowledgement</span>. You acknowledge that these Terms are concluded solely between us, and not with Apple, and Winno, not Apple, is solely responsible for the iOS App and the content thereof. You further acknowledge that the usage rules for the iOS App are subject to any additional restrictions set forth in the Usage Rules for the Apple iOS App Store Terms of Service as of the date you download the App, and in the event of any conflict, the Usage Rules in the App Store will govern if they are more restrictive. You acknowledge and agree that you have had the opportunity to review the Usage Rules.</li><br/>
            <li><span className="legal-underline-text">Scope of License</span>. The license granted to you is limited to a non-transferable license to use the iOS App on any iPhone, iPod touch or iPad that you own or control as permitted by the Usage Rules set forth in the Apple App Store Terms of Service.</li><br/>
            <li><span className="legal-underline-text">Maintenance and Support</span>. You and Winno acknowledge that Apple has no obligation whatsoever to furnish any maintenance and support services with respect to the App.</li><br/>
            <li><span className="legal-underline-text">Warranty</span>. You acknowledge that Apple is not responsible for any product warranties, whether express or implied by law, with respect to the App. In the event of any failure of the iOS App to conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price, if any, paid to Apple for the iOS App by you; and to the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the App. The parties acknowledge that to the extent that there are any applicable warranties, any other claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to any such applicable warranty would be the sole responsibility of Winno. However, you understand and agree that in accordance with these Terms, Winno has disclaimed all warranties of any kind with respect to the App, and therefore, there are no warranties applicable to the App.</li><br/>
            <li><span className="legal-underline-text">Product Claims</span>. You and Winno acknowledge that as between Apple and Winno, Winno, not Apple, is responsible for addressing any claims relating to the iOS App or your possession and/or use of the iOS App, including, but not limited to (a) product liability claims, (b) any claim that the iOS App fails to conform to any applicable legal or regulatory requirement, and (c) claims arising under consumer protection or similar legislation.</li><br/>
            <li><span className="legal-underline-text">Intellectual Property Rights</span>. The parties acknowledge that, in the event of any third-party claim that the iOS App or your possession and use of the iOS App infringe that third party's intellectual property rights, Winno, and not Apple, will be solely responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement claim to the extent required under these Terms.</li><br/>
            <li><span className="legal-underline-text">Legal Compliance</span>. You represent and warrant that (a) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a “terrorist supporting” country, and (b) you are not listed on any U.S. Government list of prohibited or restricted parties.</li><br/>
            <li><span className="legal-underline-text">Developer Name and Address</span>. Any questions, complaints or claims with respect to the iOS App should be directed to:<br/><br/>
            Winno, Inc.<br/>
            584 Castro St #2028<br/>
            San Francisco, CA 94114<br/>
            <a href="mailto:legal@winno.app">legal@winno.app</a><br/>
            </li><br/>
            <li><span className="legal-underline-text">Third-Party Terms of Agreement</span>. You agree to comply with any applicable third-party terms when using the Services</li><br/>
            <li><span className="legal-underline-text">Third-Party Beneficiary</span>. The parties acknowledge and agree that Apple, and Apple's subsidiaries, are third-party beneficiaries of these Terms, and that, upon your acceptance of these Terms, Apple will have the right (and will be deemed to have accepted the right) to enforce these Terms against you as a third-party beneficiary thereof).</li><br/>
          </ul>
          The following terms apply if you install, access or use the Services on any device that contains the Android mobile operating system (the “<span className="bold-legal-text">Android App</span>”) developed by Google, Inc. ("<span className="bold-legal-text">Google</span>”):
          <ul>
            <li>You acknowledge that these Terms are between You and us only, and not with Google.</li><br/>
            <li>Your use of our Android App must comply with Google's then-current Android Market Terms of Service.</li><br/>
            <li>Google is only a provider of the Android Market where You obtained the Android App.  We, and not Google, are solely responsible for our Android App and the Services and Content available thereon. Google has no obligation or liability to You with respect to Our Android App or these Terms.</li><br/>
            <li>You acknowledge and agree that Google is a third-party beneficiary to the Terms as they relate to our Android App.</li>
          </ul>
        </div>
        <h3 className="legal-subtitle">19. Miscellaneous</h3>
        <div>
          These Terms constitute the entire agreement between you and Winno relating to your access to and use of our Services. Notwithstanding any other provisions of these Terms, Sections 3, 6, 8, 9, 10, 11, 13, 14, 17, and 18 survive any expiration or termination of these terms. The failure of Winno to exercise or enforce any right or provision of these Terms will not operate as a waiver of such right or provision. The section titles in these Terms are for convenience only and have no legal or contractual effect. Except as otherwise provided herein, these Terms are intended solely for the benefit of the parties and are not intended to confer third-party beneficiary rights upon any other person or entity. You agree that communications and transactions between us may be conducted electronically. These Terms may not be transferred, assigned or delegated by you, by operation of law or otherwise, without our prior written consent, and any attempted transfer, assignment or delegation without such consent will be void and without effect. We may freely transfer, assign or delegate these Terms or the Services, in whole or in part, without your prior written consent. Under California Civil Code Section 1789.3, California consumers are entitled to the following specific consumer rights notice: The Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs may be contacted in writing at 1625 N. Market Blvd., Suite N-112, Sacramento, California 95834, or by telephone at 1 (800) 952-5210.
        </div>
      </div>
    )
  }

}

class Privacy extends Component {

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="legal-container">
        <img className="legal-logo" src={legal_logo} />
        <h2 className="legal-title">Privacy Policy</h2>
        <div>Last updated: 7/5/2019</div><br/>
        <div>
          Winno, Inc. ("<span className="bold-legal-text">Winno</span>," "<span className="bold-legal-text">we</span>," "<span className="bold-legal-text">us</span>") offers live, curated coverage of the biggest stories in the news and lets users customize their experience by choosing which stories to track and get notifications for. This Privacy Policy explains how we at Winno collect, use, and disclose information about you through our websites (including <a href="https://winno.app">www.winno.app</a>) mobile application (the “<span className="bold-legal-text">App</span>”), and other online products and services (collectively, the "<span className="bold-legal-text">Services</span>") or when you otherwise interact with us.<br/><br/>
          We may change this Privacy Policy from time to time.  If we make changes, we will notify you by revising the date at the top of the policy and, in some cases, we may provide you with additional notice (such as adding a statement to our homepage or sending you a notification).  We encourage you to review the Privacy Policy whenever you access the Services or otherwise interact with us to stay informed about our information practices and the choices available to you.<br/>
        </div>
        <h3>Collection of Information</h3>
        <h4>Information You Provide to Us</h4>
        <div>
          We collect information you provide directly to us.  For example, we collect information when you register and open an account on the App, participate in any interactive features of the Services, fill out a form, participate in a contest or promotion, make a purchase, apply for a job, communicate with us via third party social media sites, verify your identity, sign up for our information list and newsletter, request customer support or otherwise communicate with us, or when you otherwise choose to provide information to us.<br/><br/>
          The types of information we may collect include your first name, last name, phone number, and email address.
        </div>
        <h4>Information About Your Use of the Services</h4>
        <div>
          <i>Usage Information</i><br/>
          We collect information about your use of the Services, such as how our users generally make use of the Services, how many users download our App, and the types of stories users are interested in to be able to curate stories that match user interests.<br/><br/>
          <i>Automatically Collected Information</i><br/>
          When you access or use our Services, we automatically collect information about you, including:
          <ul>
            <li><span className="legal-underline-text">Log Information</span>:  We collect log information about your use of the Services, including the type of browser you use, app version, access times, pages viewed, your IP address and the page you visited before navigating to our Services.</li><br/>
            <li><span className="legal-underline-text">Device Information</span>:  We collect information about the computer or mobile device you use to access our Services, including the hardware model, operating system and version, unique device identifiers, and mobile network information.<br/>With your consent, we may also send you push notifications and save images to your devices (e.g., to your camera roll) if you share a post.</li><br/>
            <li><span className="legal-underline-text">Information Collected by Cookies and Other Tracking Technologies:</span> We may use different technologies to collect information, including cookies and web beacons.  Cookies are small data files stored on your hard drive or in device memory that help us improve our Services and your experience, see which areas and features of our Services are popular, and count visits.  Web beacons are electronic images that may be used in our Services or emails and help deliver cookies, count visits and understand usage.  For more information about cookies and how to disable them, please see "Your Choices" below.</li>
          </ul>
        </div>
        <h4>Information About Your Use of the Services</h4>
        <div>
          We may obtain information from other sources and combine that with information we collect through our Services.  For example, we may collect information about you from third parties such as publicly available sources. Additionally, if you create or log into your account through a social media site, we will have access to certain information from that site, such as your name, basic account information, and profile picture, in accordance with the authorization procedures determined by such social media site.
        </div>
        <h3>Use of Information</h3>
        <div>
          We may use the information we collect to provide, maintain, and improve our Services, to customize your experience, provide you with notifications, and to administer your account.  We may also use the information we collect to:
          <ul>
            <li>Send you technical notices, updates, security alerts and support and administrative messages, as well as to respond to your comments, questions and customer service requests;</li><br/>
            <li>Communicate with you about products, services, offers, and events offered by Winno and others, and provide news and information we think will be of interest to you;</li><br/>
            <li>Monitor and analyze trends, usage and activities in connection with our Services; </li><br/>
            <li>Detect, investigate and prevent fraudulent transactions and other illegal activities and protect the rights and property of Winno and others;</li><br/>
            <li>Personalize and improve the Services and provide content or features that match your interests;</li><br/>
            <li>Facilitate contests, sweepstakes and promotions and process and deliver entries and rewards; and</li><br/>
            <li>Carry out any other purpose described to you at the time the information was collected.</li>
          </ul>
        </div>
        <h3>Sharing of Information</h3>
        <div>
          We may share information about you as follows or as otherwise described in this Privacy Policy:
          <ul>
            <li>With vendors, consultants, integrated technology providers, and other service providers who need access to such information to carry out work on our behalf;</li><br/>
            <li>In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law or legal process, including lawful requests by public authorities to meet national security or law enforcement requirements;</li><br/>
            <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property and safety of Winno or others;</li><br/>
            <li>In connection with, or during negotiations of, any merger, sale of company assets, financing or acquisition of all or a portion of our business by another company; </li><br/>
            <li>Between and among Winno and our current and future parents, affiliates, subsidiaries and other companies under common control and ownership; and</li><br/>
            <li>With your consent or at your direction.</li>
          </ul>
          We may also share aggregated or de-identified information, which cannot reasonably be used to identify you but could potentially be used to identify your device. For example, we may share aggregated information about how people use our Services.
        </div>
        <h3>Social Sharing Features</h3>
        <div>
          The Services may offer social sharing features and other integrated tools, which let you share actions you take on our Services with other media, and vice versa.   Your use of such features enables the sharing of information with your friends or the public, depending on the settings you establish with the entity that provides the social sharing feature.  For more information about the purpose and scope of data collection and processing in connection with social sharing features, please visit the privacy policies of the entities that provide these features.
        </div>
        <h3>Advertising and Analytics Services Provided by Others</h3>
        <div>
          We may allow others to provide analytics services and serve advertisements on our behalf across the web.  These entities may use cookies, web beacons, device identifiers and other technologies to collect information about your use of the Services and other websites and applications, including your IP address, web browser, mobile network information, pages viewed, time spent on pages or in the App, links clicked, and conversion information.  This information may be used by Winno and others to, among other things, analyze and track data, determine the popularity of certain content, deliver advertising and content targeted to your interests on our Services and other websites, and better understand your online activity.  For more information about interest-based ads, or to opt out of having your web browsing information used for behavioral advertising purposes, please visit <a href="www.aboutads.info/choices">www.aboutads.info/choices</a>.
        </div>
        <h3>Data Retention</h3>
        <div>
          We store the information we collect about you for as long as is necessary for the purpose(s) for which we originally collected it.  We may retain certain information for legitimate business purposes or as required by law.
        </div>
        <h3>Transfer of Information to the U.S. and Other Countries</h3>
        <div>
          Winno is based in the United States and we process and store information in the U.S.  As such, we and our service providers may transfer your information to, or store or access it in, jurisdictions that may not provide equivalent levels of data protection as your home jurisdiction.  We will take steps to ensure that your personal data receives an adequate level of protection in the jurisdictions in which we process it.
        </div>
        <h3>Your Choices</h3>
        <h4>Account Information</h4>
        <div>
          You may access, update, or correct information about you at any time through the App or by emailing us at <a href="mailto:legal@winno.app">legal@winno.app</a>.  If you wish to delete or deactivate your account or to change your listed telephone number, you can also email us at <a href="mailto:legal@winno.app">legal@winno.app</a>
        </div>
        <h4>Rights to Erasure</h4>
        <div>
          You have the right to ask us to delete personal information about you if it no longer is required for the purpose it was collected, you have withdrawn your consent, you have a valid objection to us using your personal information, or our use of your personal information is contrary to law or our other legal obligations. You can do this by emailing us at <a href="mailto:legal@winno.app">legal@winno.app</a>.
        </div>
        <h4>Cookies</h4>
        <div>
          Most web browsers are set to accept cookies by default.  If you prefer, you can usually choose to set your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of our Services.
        </div>
        <h4>Promotional Communications</h4>
        <div>
          You may opt out of receiving promotional emails from Winno by following the instructions in those emails or by emailing us at <a href="mailto:legal@winno.app">legal@winno.app</a>. If you opt out, we may still send you non-promotional emails, such as those about your account or our ongoing business relations.
        </div>
        <h4>Mobile Push Notifications/Alerts</h4>
        <div>
          With your consent, we may send promotional and non-promotional push notifications or alerts to your mobile device.  You can deactivate these messages at any time by changing the notification settings on your mobile device.
        </div>
        <h4>Device Content on the Mobile Application</h4>
        <div>
          With your consent, we may store information on your device if choose to save images or pictures to your camera roll or device memory. You can always withdraw such access by going into your device settings and removing the application's access to that information. Please note that if you enable access and then remove that access, this could affect the availability and functionality of our Services and of certain features of the mobile application.
        </div>
        <h3>Contact Us</h3>
        <div>
          If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:legal@winno.app">legal@winno.app</a>.
        </div>
      </div>
    )
  }

}

class Contact extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_thanks: false
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.attributes["data-content"].value]: e.target.value
    })
  }

  submit() {
    this.setState({
      show_thanks: true
    })
    var data = {
      name: this.state.name,
      email: this.state.email,
			message: this.state.message
    }
    fetch(BASE_API_URL + '/v1/contact', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
			.then(res => {
				// console.log(res);
			})
  }

  render() {
    return (
      <div className="contact-container contact-web-container" id="contact">
        <div className="contact-form-container contact-web-form-container">
          {!this.state.show_thanks &&
            <div className="contact-form-container-input">
              <div className="section-title contact-section-title">
                Contact us
              </div>
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input web-input" data-content="name" placeholder="name" />
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input web-input" data-content="email" placeholder="email" />
              <textarea type="text" onChange={this.handleChange.bind(this)} className="contact-input web-input" data-content="message" placeholder="message"></textarea>
              <div className="contact-submit contact-web-submit" onClick={this.submit.bind(this)}>
                <i class="fas fa-paper-plane"></i>
                send message
              </div>
            </div>
          }
          {this.state.show_thanks &&
            <div className="contact-thanks-container">
              <div className="contact-thanks-title">
                Thank you!
              </div>
              <div className="contact-thanks-subtitle">
                Our team will respond shortly.
              </div>
            </div>
          }
        </div>
      </div>
    )
  }

}

class ContactMobile extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_thanks: false
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.attributes["data-content"].value]: e.target.value
    })
  }

  submit() {
    this.setState({
      show_thanks: true
    })
    window.scrollTo(0, 0);
    var data = {
      name: this.state.name,
      email: this.state.email,
			message: this.state.message
    }
    fetch(BASE_API_URL + '/v1/contact', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
			.then(res => {
				// console.log(res);
			})
  }

  render() {
    return (
      <div className="contact-container">
        <div className="contact-form-container">
          {!this.state.show_thanks &&
            <div className="contact-form-container-input">
              <div className="contact-title">contact us</div>
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="name" placeholder="name" />
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="email" placeholder="email" />
              <textarea type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="message" placeholder="message"></textarea>
              <div className="contact-submit" onClick={this.submit.bind(this)}>
                <i class="fas fa-paper-plane"></i>
                submit
              </div>
            </div>
          }
          {this.state.show_thanks &&
            <div className="contact-thanks-container">
              <div className="contact-thanks-title">
                Thank you!
              </div>
              <div className="contact-thanks-subtitle">
                Our team will respond shortly.
              </div>
            </div>
          }
        </div>
      </div>
    )
  }

}

class Question extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show_thanks: false,
      loading: true
    }
    fetch(BASE_API_URL + '/v1/feeds/' + this.props.feed_id)
			.then(res => res.json())
			.then(data => {
				this.setState({
          feed_color: data.feed.color,
          feed_name: data.feed.name,
          loading: false
        })
			})
  }

  handleChange(e) {
    this.setState({
      [e.target.attributes["data-content"].value]: e.target.value
    })
  }

  submit() {
    this.setState({
      show_thanks: true
    })
    window.scrollTo(0, 0);
    var data = {
      name: this.state.name,
      email: this.state.email,
			question: this.state.question,
      feed: this.state.feed_name
    }
    fetch(BASE_API_URL + '/v1/contact', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
			.then(res => {
				// console.log(res);
			})
  }

  render() {
    return (
      <div className="contact-container">
        <div className="contact-form-container">
          {this.state.loading &&
            <div className="loading-container">
              <ClipLoader
                className="loading-spinner"
                sizeUnit={"px"}
                size={100}
                color={'#BBBBBB'}
                loading={this.state.loading}
              />
            </div>
          }
          {!this.state.loading && !this.state.show_thanks &&
            <div className="contact-form-container-input">
              <div className="contact-slug-container">
                <div className="contact-slug" style={{backgroundColor: this.state.feed_color}}>
                  <i class="fas fa-hashtag"></i>
                  {this.state.feed_name}
                </div>
              </div>
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="name" placeholder="name" />
              <input type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="email" placeholder="email" />
              <textarea type="text" onChange={this.handleChange.bind(this)} className="contact-input" data-content="question" placeholder="question"></textarea>
              <div className="contact-submit" onClick={this.submit.bind(this)}>
                <i class="fas fa-paper-plane"></i>
                submit
              </div>
            </div>
          }
          {!this.state.loading && this.state.show_thanks &&
            <div className="contact-thanks-container">
              <div className="contact-thanks-title">
                Thank you!
              </div>
              <div className="contact-thanks-subtitle">
                Our team will respond shortly.
              </div>
            </div>
          }
        </div>
      </div>
    )
  }

}

class FeedTile extends Component {

  render() {
    return (
      <div className="feed-tile-container">
        <div className="feed-tile" style={{backgroundColor: this.props.color}}>
          <div className="feed-image-container">
            <img src={this.props.image_url} className="feed-tile-image" draggable="false" />
          </div>
          <div className="feed-slug-container">
            <div className="feed-tile-slug">
              <i class="fas fa-hashtag"></i>
              {this.props.name}
            </div>
          </div>
          {/*<div className="feed-description">
            {this.props.description}
          </div>*/}
          <div className="feed-metadata">
            <i class="fas fa-bars"></i>
            {Math.floor(Math.random() * 250) + 50}
            <i class="fas fa-sync-alt"></i>
            <TimeAgo date={this.props.updated_at} formatter={(value, unit, suffix, epochSeconds) => value + " " + unit + "s"}/>
          </div>
        </div>
      </div>
    )
  }

}

class Feed extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    fetch(BASE_API_URL + '/v1/feeds/' + this.props.name)
			.then(res => res.json())
			.then(data => {
				let feed_header = (
          <FeedHeader name={data.feed.name} color={data.feed.color} image_url={data.feed.image_url} description={data.feed.description} />
        )
        this.setState({
          feed_header: feed_header
        })
			})
  }

  render() {
    return (
      <div className="feed-container">
        {this.state.feed_header}
        <div className="feed-updates-container">
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
          <div className="feed-update-container">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pulvinar elit dolor, ac lacinia augue maximus eget.
          </div>
        </div>
      </div>
    )
  }

}

class FeedHeader extends Component {

  render() {
    return (
      <div className="feed-header-container">
        <div className="feed-header" style={{backgroundColor: this.props.color}}>
          <div className="feed-header-top-container">
            <img src={this.props.image_url} className="feed-header-image" draggable="false" />
          </div>
          <div className="feed-header-bottom-container">
            <FeedSlug name={this.props.name} color={this.props.color} />
            <div className="header-description-container">
              {this.props.description}
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class Footer extends Component {
  render() {
    return (
      <div className="footer-container">
        <div className="footer-text">
          © Winno Inc. 2020. View our <a href="/terms" target="_blank">Terms</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.
        </div>
        <div className="footer-text mobile-footer-text">
          © Winno Inc. 2020. <a href="/terms" target="_blank">Terms</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.
        </div>
      </div>
    )
  }
}

export default App
